'use strict';

var cov_1sqtzwujiq = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\user\\privileges\\privilegesCtrl.js',
      hash = '11f89a6e95209ba2fe73433ba5b49fcc06929c85',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\user\\privileges\\privilegesCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 205,
          column: 3
        }
      },
      '1': {
        start: {
          line: 6,
          column: 20
        },
        end: {
          line: 6,
          column: 26
        }
      },
      '2': {
        start: {
          line: 7,
          column: 21
        },
        end: {
          line: 7,
          column: 29
        }
      },
      '3': {
        start: {
          line: 8,
          column: 22
        },
        end: {
          line: 8,
          column: 31
        }
      },
      '4': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 18,
          column: 4
        }
      },
      '5': {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 30
        }
      },
      '6': {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 16,
          column: 9
        }
      },
      '7': {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 39
        }
      },
      '8': {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 33
        }
      },
      '9': {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 202,
          column: 4
        }
      },
      '10': {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 54,
          column: 9
        }
      },
      '11': {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 38,
          column: 9
        }
      },
      '12': {
        start: {
          line: 37,
          column: 10
        },
        end: {
          line: 37,
          column: 17
        }
      },
      '13': {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 32
        }
      },
      '14': {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 35
        }
      },
      '15': {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 35
        }
      },
      '16': {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 53,
          column: 11
        }
      },
      '17': {
        start: {
          line: 43,
          column: 10
        },
        end: {
          line: 50,
          column: 11
        }
      },
      '18': {
        start: {
          line: 44,
          column: 12
        },
        end: {
          line: 47,
          column: 15
        }
      },
      '19': {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 37
        }
      },
      '20': {
        start: {
          line: 49,
          column: 12
        },
        end: {
          line: 49,
          column: 19
        }
      },
      '21': {
        start: {
          line: 51,
          column: 10
        },
        end: {
          line: 51,
          column: 34
        }
      },
      '22': {
        start: {
          line: 52,
          column: 10
        },
        end: {
          line: 52,
          column: 34
        }
      },
      '23': {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 30
        }
      },
      '24': {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 61,
          column: 9
        }
      },
      '25': {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 35
        }
      },
      '26': {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 33
        }
      },
      '27': {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 69,
          column: 16
        }
      },
      '28': {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 74,
          column: 7
        }
      },
      '29': {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 15
        }
      },
      '30': {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 40
        }
      },
      '31': {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 40
        }
      },
      '32': {
        start: {
          line: 77,
          column: 19
        },
        end: {
          line: 77,
          column: 50
        }
      },
      '33': {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 88,
          column: 7
        }
      },
      '34': {
        start: {
          line: 81,
          column: 22
        },
        end: {
          line: 81,
          column: 47
        }
      },
      '35': {
        start: {
          line: 83,
          column: 18
        },
        end: {
          line: 83,
          column: 78
        }
      },
      '36': {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 86,
          column: 9
        }
      },
      '37': {
        start: {
          line: 85,
          column: 10
        },
        end: {
          line: 85,
          column: 19
        }
      },
      '38': {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 45
        }
      },
      '39': {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 96,
          column: 7
        }
      },
      '40': {
        start: {
          line: 91,
          column: 22
        },
        end: {
          line: 91,
          column: 47
        }
      },
      '41': {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 94,
          column: 9
        }
      },
      '42': {
        start: {
          line: 93,
          column: 10
        },
        end: {
          line: 93,
          column: 19
        }
      },
      '43': {
        start: {
          line: 95,
          column: 8
        },
        end: {
          line: 95,
          column: 35
        }
      },
      '44': {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 40
        }
      },
      '45': {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 98,
          column: 40
        }
      },
      '46': {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 101,
          column: 7
        }
      },
      '47': {
        start: {
          line: 100,
          column: 8
        },
        end: {
          line: 100,
          column: 32
        }
      },
      '48': {
        start: {
          line: 102,
          column: 6
        },
        end: {
          line: 116,
          column: 9
        }
      },
      '49': {
        start: {
          line: 103,
          column: 8
        },
        end: {
          line: 114,
          column: 9
        }
      },
      '50': {
        start: {
          line: 104,
          column: 10
        },
        end: {
          line: 109,
          column: 11
        }
      },
      '51': {
        start: {
          line: 105,
          column: 12
        },
        end: {
          line: 108,
          column: 13
        }
      },
      '52': {
        start: {
          line: 106,
          column: 14
        },
        end: {
          line: 106,
          column: 46
        }
      },
      '53': {
        start: {
          line: 107,
          column: 14
        },
        end: {
          line: 107,
          column: 20
        }
      },
      '54': {
        start: {
          line: 111,
          column: 10
        },
        end: {
          line: 111,
          column: 35
        }
      },
      '55': {
        start: {
          line: 112,
          column: 10
        },
        end: {
          line: 112,
          column: 25
        }
      },
      '56': {
        start: {
          line: 113,
          column: 10
        },
        end: {
          line: 113,
          column: 41
        }
      },
      '57': {
        start: {
          line: 115,
          column: 8
        },
        end: {
          line: 115,
          column: 43
        }
      },
      '58': {
        start: {
          line: 119,
          column: 6
        },
        end: {
          line: 152,
          column: 7
        }
      },
      '59': {
        start: {
          line: 120,
          column: 8
        },
        end: {
          line: 151,
          column: 10
        }
      },
      '60': {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 45
        }
      },
      '61': {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 155,
          column: 72
        }
      },
      '62': {
        start: {
          line: 156,
          column: 6
        },
        end: {
          line: 156,
          column: 72
        }
      },
      '63': {
        start: {
          line: 158,
          column: 6
        },
        end: {
          line: 158,
          column: 46
        }
      },
      '64': {
        start: {
          line: 159,
          column: 19
        },
        end: {
          line: 159,
          column: 21
        }
      },
      '65': {
        start: {
          line: 160,
          column: 19
        },
        end: {
          line: 160,
          column: 57
        }
      },
      '66': {
        start: {
          line: 161,
          column: 6
        },
        end: {
          line: 164,
          column: 7
        }
      },
      '67': {
        start: {
          line: 162,
          column: 18
        },
        end: {
          line: 162,
          column: 31
        }
      },
      '68': {
        start: {
          line: 163,
          column: 8
        },
        end: {
          line: 163,
          column: 26
        }
      },
      '69': {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 192,
          column: 7
        }
      },
      '70': {
        start: {
          line: 166,
          column: 8
        },
        end: {
          line: 191,
          column: 9
        }
      },
      '71': {
        start: {
          line: 168,
          column: 12
        },
        end: {
          line: 168,
          column: 74
        }
      },
      '72': {
        start: {
          line: 169,
          column: 12
        },
        end: {
          line: 169,
          column: 18
        }
      },
      '73': {
        start: {
          line: 171,
          column: 12
        },
        end: {
          line: 171,
          column: 73
        }
      },
      '74': {
        start: {
          line: 172,
          column: 12
        },
        end: {
          line: 172,
          column: 18
        }
      },
      '75': {
        start: {
          line: 174,
          column: 12
        },
        end: {
          line: 174,
          column: 73
        }
      },
      '76': {
        start: {
          line: 175,
          column: 12
        },
        end: {
          line: 175,
          column: 18
        }
      },
      '77': {
        start: {
          line: 177,
          column: 12
        },
        end: {
          line: 177,
          column: 73
        }
      },
      '78': {
        start: {
          line: 178,
          column: 12
        },
        end: {
          line: 178,
          column: 18
        }
      },
      '79': {
        start: {
          line: 180,
          column: 12
        },
        end: {
          line: 180,
          column: 73
        }
      },
      '80': {
        start: {
          line: 181,
          column: 12
        },
        end: {
          line: 181,
          column: 18
        }
      },
      '81': {
        start: {
          line: 183,
          column: 12
        },
        end: {
          line: 183,
          column: 72
        }
      },
      '82': {
        start: {
          line: 184,
          column: 12
        },
        end: {
          line: 184,
          column: 18
        }
      },
      '83': {
        start: {
          line: 186,
          column: 12
        },
        end: {
          line: 186,
          column: 72
        }
      },
      '84': {
        start: {
          line: 187,
          column: 12
        },
        end: {
          line: 187,
          column: 18
        }
      },
      '85': {
        start: {
          line: 189,
          column: 12
        },
        end: {
          line: 189,
          column: 75
        }
      },
      '86': {
        start: {
          line: 190,
          column: 12
        },
        end: {
          line: 190,
          column: 18
        }
      },
      '87': {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 194,
          column: 46
        }
      },
      '88': {
        start: {
          line: 195,
          column: 6
        },
        end: {
          line: 197,
          column: 7
        }
      },
      '89': {
        start: {
          line: 196,
          column: 8
        },
        end: {
          line: 196,
          column: 54
        }
      },
      '90': {
        start: {
          line: 200,
          column: 6
        },
        end: {
          line: 200,
          column: 31
        }
      },
      '91': {
        start: {
          line: 203,
          column: 2
        },
        end: {
          line: 203,
          column: 33
        }
      },
      '92': {
        start: {
          line: 204,
          column: 2
        },
        end: {
          line: 204,
          column: 26
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 5,
            column: 51
          },
          end: {
            line: 5,
            column: 52
          }
        },
        loc: {
          start: {
            line: 5,
            column: 166
          },
          end: {
            line: 205,
            column: 1
          }
        },
        line: 5
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 13,
            column: 56
          },
          end: {
            line: 13,
            column: 57
          }
        },
        loc: {
          start: {
            line: 13,
            column: 64
          },
          end: {
            line: 16,
            column: 7
          }
        },
        line: 13
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 35,
            column: 10
          }
        },
        loc: {
          start: {
            line: 35,
            column: 22
          },
          end: {
            line: 54,
            column: 7
          }
        },
        line: 35
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 42,
            column: 89
          },
          end: {
            line: 42,
            column: 90
          }
        },
        loc: {
          start: {
            line: 42,
            column: 97
          },
          end: {
            line: 53,
            column: 9
          }
        },
        line: 42
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 58,
            column: 53
          },
          end: {
            line: 58,
            column: 54
          }
        },
        loc: {
          start: {
            line: 58,
            column: 61
          },
          end: {
            line: 61,
            column: 7
          }
        },
        line: 58
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 102,
            column: 91
          },
          end: {
            line: 102,
            column: 92
          }
        },
        loc: {
          start: {
            line: 102,
            column: 99
          },
          end: {
            line: 116,
            column: 7
          }
        },
        line: 102
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        }, {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        }],
        line: 36
      },
      '1': {
        loc: {
          start: {
            line: 43,
            column: 10
          },
          end: {
            line: 50,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 43,
            column: 10
          },
          end: {
            line: 50,
            column: 11
          }
        }, {
          start: {
            line: 43,
            column: 10
          },
          end: {
            line: 50,
            column: 11
          }
        }],
        line: 43
      },
      '2': {
        loc: {
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        }, {
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        }],
        line: 72
      },
      '3': {
        loc: {
          start: {
            line: 83,
            column: 19
          },
          end: {
            line: 83,
            column: 35
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 83,
            column: 30
          },
          end: {
            line: 83,
            column: 31
          }
        }, {
          start: {
            line: 83,
            column: 34
          },
          end: {
            line: 83,
            column: 35
          }
        }],
        line: 83
      },
      '4': {
        loc: {
          start: {
            line: 83,
            column: 40
          },
          end: {
            line: 83,
            column: 56
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 83,
            column: 51
          },
          end: {
            line: 83,
            column: 52
          }
        }, {
          start: {
            line: 83,
            column: 55
          },
          end: {
            line: 83,
            column: 56
          }
        }],
        line: 83
      },
      '5': {
        loc: {
          start: {
            line: 83,
            column: 61
          },
          end: {
            line: 83,
            column: 77
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 83,
            column: 72
          },
          end: {
            line: 83,
            column: 73
          }
        }, {
          start: {
            line: 83,
            column: 76
          },
          end: {
            line: 83,
            column: 77
          }
        }],
        line: 83
      },
      '6': {
        loc: {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }, {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }],
        line: 84
      },
      '7': {
        loc: {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        }, {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        }],
        line: 92
      },
      '8': {
        loc: {
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 101,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 101,
            column: 7
          }
        }, {
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 101,
            column: 7
          }
        }],
        line: 99
      },
      '9': {
        loc: {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 114,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 114,
            column: 9
          }
        }, {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 114,
            column: 9
          }
        }],
        line: 103
      },
      '10': {
        loc: {
          start: {
            line: 105,
            column: 12
          },
          end: {
            line: 108,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 105,
            column: 12
          },
          end: {
            line: 108,
            column: 13
          }
        }, {
          start: {
            line: 105,
            column: 12
          },
          end: {
            line: 108,
            column: 13
          }
        }],
        line: 105
      },
      '11': {
        loc: {
          start: {
            line: 119,
            column: 6
          },
          end: {
            line: 152,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 119,
            column: 6
          },
          end: {
            line: 152,
            column: 7
          }
        }, {
          start: {
            line: 119,
            column: 6
          },
          end: {
            line: 152,
            column: 7
          }
        }],
        line: 119
      },
      '12': {
        loc: {
          start: {
            line: 155,
            column: 37
          },
          end: {
            line: 155,
            column: 70
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 155,
            column: 37
          },
          end: {
            line: 155,
            column: 64
          }
        }, {
          start: {
            line: 155,
            column: 68
          },
          end: {
            line: 155,
            column: 70
          }
        }],
        line: 155
      },
      '13': {
        loc: {
          start: {
            line: 156,
            column: 37
          },
          end: {
            line: 156,
            column: 70
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 156,
            column: 37
          },
          end: {
            line: 156,
            column: 64
          }
        }, {
          start: {
            line: 156,
            column: 68
          },
          end: {
            line: 156,
            column: 70
          }
        }],
        line: 156
      },
      '14': {
        loc: {
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 191,
            column: 9
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 167,
            column: 10
          },
          end: {
            line: 169,
            column: 18
          }
        }, {
          start: {
            line: 170,
            column: 10
          },
          end: {
            line: 172,
            column: 18
          }
        }, {
          start: {
            line: 173,
            column: 10
          },
          end: {
            line: 175,
            column: 18
          }
        }, {
          start: {
            line: 176,
            column: 10
          },
          end: {
            line: 178,
            column: 18
          }
        }, {
          start: {
            line: 179,
            column: 10
          },
          end: {
            line: 181,
            column: 18
          }
        }, {
          start: {
            line: 182,
            column: 10
          },
          end: {
            line: 184,
            column: 18
          }
        }, {
          start: {
            line: 185,
            column: 10
          },
          end: {
            line: 187,
            column: 18
          }
        }, {
          start: {
            line: 188,
            column: 10
          },
          end: {
            line: 190,
            column: 18
          }
        }],
        line: 166
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0, 0, 0, 0, 0, 0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_1sqtzwujiq.s[0]++;
/**
 * Created by BKSB on 16/04/2017.
 */

angular.module('app').controller('privilegesCtrl', function ($scope, $rootScope, SweetAlert, $translate, $deltaActor, $CRUDService, $otherHttpService, $deltahttp, $filter) {
  cov_1sqtzwujiq.f[0]++;

  var PATH_USER = (cov_1sqtzwujiq.s[1]++, 'User');
  var PATH_RIGHT = (cov_1sqtzwujiq.s[2]++, 'Droits');
  var PATH_PROFIL = (cov_1sqtzwujiq.s[3]++, 'Profils');

  cov_1sqtzwujiq.s[4]++;
  $scope.privileges = {
    getAllUser: function getAllUser() {
      cov_1sqtzwujiq.s[5]++;

      $scope.isloading = true;
      cov_1sqtzwujiq.s[6]++;
      $CRUDService.getAll(PATH_USER, { get: 'NonAdmin' }, function (data) {
        cov_1sqtzwujiq.f[1]++;
        cov_1sqtzwujiq.s[7]++;

        $scope.privileges.users = data;
        cov_1sqtzwujiq.s[8]++;
        $scope.isloading = false;
      });
    }
  };

  cov_1sqtzwujiq.s[9]++;
  $scope.profils = {
    data: null,
    selectedItem: null,
    deleteItem: function deleteItem(item) {
      cov_1sqtzwujiq.s[10]++;

      SweetAlert.swal({
        title: $translate.instant('COMMON.CONFIRM'),
        text: $translate.instant('RIGHT.CONFIRM_DELETE'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#c8c8c8',
        cancelButtonColor: '#DD6B55',
        confirmButtonText: $translate.instant('COMMON.YES'),
        cancelButtonText: $translate.instant('COMMON.NO'),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isconfirm) {
        cov_1sqtzwujiq.f[2]++;
        cov_1sqtzwujiq.s[11]++;

        if (!isconfirm) {
          cov_1sqtzwujiq.b[0][0]++;
          cov_1sqtzwujiq.s[12]++;

          return;
        } else {
          cov_1sqtzwujiq.b[0][1]++;
        }
        cov_1sqtzwujiq.s[13]++;
        $scope.isloading = true;
        cov_1sqtzwujiq.s[14]++;
        item.USER_LIST = undefined;
        cov_1sqtzwujiq.s[15]++;
        item.RIGHT_STR = undefined;
        cov_1sqtzwujiq.s[16]++;
        $CRUDService.delet(PATH_PROFIL, { action: 'supp', valeur: $filter('json')(item) }, function (data) {
          cov_1sqtzwujiq.f[3]++;
          cov_1sqtzwujiq.s[17]++;

          if (data < 0) {
            cov_1sqtzwujiq.b[1][0]++;
            cov_1sqtzwujiq.s[18]++;

            SweetAlert.swal({
              title: $translate.instant('COMMON.ERROR_DELETE'),
              text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
            });
            cov_1sqtzwujiq.s[19]++;
            $scope.isloading = false;
            cov_1sqtzwujiq.s[20]++;
            return;
          } else {
            cov_1sqtzwujiq.b[1][1]++;
          }
          cov_1sqtzwujiq.s[21]++;
          $scope.profils.cancel();
          cov_1sqtzwujiq.s[22]++;
          $scope.profils.getAll();
        });
      });
    },
    getAll: function getAll() {
      cov_1sqtzwujiq.s[23]++;

      $scope.isloading = true;
      cov_1sqtzwujiq.s[24]++;
      $CRUDService.getAll(PATH_PROFIL, { get: 'all' }, function (data) {
        cov_1sqtzwujiq.f[4]++;
        cov_1sqtzwujiq.s[25]++;

        $scope.profils.data = data;
        cov_1sqtzwujiq.s[26]++;
        $scope.isloading = false;
      });
    },
    addItem: function addItem(label) {
      cov_1sqtzwujiq.s[27]++;

      this.edit({
        id: 0,
        LABEL_PROFIL: '',
        USER_LIST: '',
        RIGHT_STR: ''
      }, label);
    },
    validate: function validate() {
      cov_1sqtzwujiq.s[28]++;

      if ($scope.isloading) {
        cov_1sqtzwujiq.b[2][0]++;
        cov_1sqtzwujiq.s[29]++;

        return;
      } else {
        cov_1sqtzwujiq.b[2][1]++;
      }
      cov_1sqtzwujiq.s[30]++;
      this.selectedItem.RIGHT_STR = ';';
      cov_1sqtzwujiq.s[31]++;
      this.selectedItem.USER_LIST = ';';
      var item = (cov_1sqtzwujiq.s[32]++, angular.copy(this.selectedItem));

      // Droit
      cov_1sqtzwujiq.s[33]++;
      for (var el in item.RIGHT_STR__TABLE) {
        var value = (cov_1sqtzwujiq.s[34]++, item.RIGHT_STR__TABLE[el]);

        var d = (cov_1sqtzwujiq.s[35]++, (value[0] ? (cov_1sqtzwujiq.b[3][0]++, 1) : (cov_1sqtzwujiq.b[3][1]++, 0)) + (value[1] ? (cov_1sqtzwujiq.b[4][0]++, 2) : (cov_1sqtzwujiq.b[4][1]++, 0)) + (value[2] ? (cov_1sqtzwujiq.b[5][0]++, 4) : (cov_1sqtzwujiq.b[5][1]++, 0)));
        cov_1sqtzwujiq.s[36]++;
        if (d == 0) {
          cov_1sqtzwujiq.b[6][0]++;
          cov_1sqtzwujiq.s[37]++;

          continue;
        } else {
          cov_1sqtzwujiq.b[6][1]++;
        }
        cov_1sqtzwujiq.s[38]++;
        item.RIGHT_STR += el + ':' + d + ';';
      }
      // User
      cov_1sqtzwujiq.s[39]++;
      for (var _el in item.USER_LIST__TABLE) {
        var _value = (cov_1sqtzwujiq.s[40]++, item.USER_LIST__TABLE[_el]);
        cov_1sqtzwujiq.s[41]++;
        if (!_value) {
          cov_1sqtzwujiq.b[7][0]++;
          cov_1sqtzwujiq.s[42]++;

          continue;
        } else {
          cov_1sqtzwujiq.b[7][1]++;
        }
        cov_1sqtzwujiq.s[43]++;
        item.USER_LIST += _el + ';';
      }
      cov_1sqtzwujiq.s[44]++;
      item.USER_LIST__TABLE = undefined;
      cov_1sqtzwujiq.s[45]++;
      item.RIGHT_STR__TABLE = undefined;
      cov_1sqtzwujiq.s[46]++;
      if (item.id == 0) {
        cov_1sqtzwujiq.b[8][0]++;
        cov_1sqtzwujiq.s[47]++;

        $scope.isloading = true;
      } else {
        cov_1sqtzwujiq.b[8][1]++;
      }
      cov_1sqtzwujiq.s[48]++;
      $CRUDService.save(PATH_PROFIL, { action: 'miseAJour', valeur: $filter('json')(item) }, function (data) {
        cov_1sqtzwujiq.f[5]++;
        cov_1sqtzwujiq.s[49]++;

        if (!$scope.isloading) {
          cov_1sqtzwujiq.b[9][0]++;
          cov_1sqtzwujiq.s[50]++;

          for (var ind = $scope.profils.data.length - 1; ind >= 0; ind--) {
            cov_1sqtzwujiq.s[51]++;

            if ($scope.profils.data[ind].id == data) {
              cov_1sqtzwujiq.b[10][0]++;
              cov_1sqtzwujiq.s[52]++;

              $scope.profils.data[ind] = item;
              cov_1sqtzwujiq.s[53]++;
              break;
            } else {
              cov_1sqtzwujiq.b[10][1]++;
            }
          }
        } else {
          cov_1sqtzwujiq.b[9][1]++;
          cov_1sqtzwujiq.s[54]++;

          $scope.isloading = false;
          cov_1sqtzwujiq.s[55]++;
          item.id = data;
          cov_1sqtzwujiq.s[56]++;
          $scope.profils.data.push(item);
        }
        cov_1sqtzwujiq.s[57]++;
        $scope.profils.selectedItem = null;
      });
    },
    edit: function edit(item, labelPL) {
      cov_1sqtzwujiq.s[58]++;

      if (!$scope.moduleList) {
        cov_1sqtzwujiq.b[11][0]++;
        cov_1sqtzwujiq.s[59]++;

        $scope.moduleList = [{
          id: 1,
          name: $translate.instant('MENU.D_B'),
          items: [{ id: 1, name: $translate.instant('MENU.DO'), blocks: [false, true, true] }, { id: 2, name: $translate.instant('MENU.UN'), blocks: [true, true, true] }, { id: 3, name: $translate.instant('MENU.AC'), blocks: [true, true, true] }, { id: 4, name: $translate.instant('MENU.P_G'), blocks: [true, true, true] }, { id: 5, name: labelPL, blocks: [true, true, true] }, { id: 6, name: $translate.instant('MENU.FL'), blocks: [true, true, true] }, { id: 7, name: $translate.instant('MENU.ALERT'), blocks: [true, true, false] }]
        }, {
          id: 3,
          name: $translate.instant('MENU.IN_T'),
          items: [{ id: 1, name: $translate.instant('MENU.T_I'), blocks: [true, true, true] }, { id: 2, name: $translate.instant('MENU.IN'), blocks: [true, true, true] }, { id: 3, name: $translate.instant('MENU.R_F'), blocks: [true, false, false] }]
        }, {
          id: 5,
          name: $translate.instant('MENU.B_D'),
          items: [{ id: 1, name: $translate.instant('MENU.T_RA'), blocks: [true, true, true] }, { id: 2, name: $translate.instant('MENU.CA_R'), blocks: [true, true, false] }, { id: 3, name: $translate.instant('MENU.C_D'), blocks: [true, true, true] }, { id: 4, name: $translate.instant('MENU.PH'), blocks: [true, true, true] }]
        }];
      } else {
        cov_1sqtzwujiq.b[11][1]++;
      }

      cov_1sqtzwujiq.s[60]++;
      this.selectedItem = angular.copy(item);
      cov_1sqtzwujiq.s[61]++;
      this.selectedItem.RIGHT_STR = (cov_1sqtzwujiq.b[12][0]++, this.selectedItem.RIGHT_STR) || (cov_1sqtzwujiq.b[12][1]++, '');
      cov_1sqtzwujiq.s[62]++;
      this.selectedItem.USER_LIST = (cov_1sqtzwujiq.b[13][0]++, this.selectedItem.USER_LIST) || (cov_1sqtzwujiq.b[13][1]++, '');
      // Parametrage des droits
      cov_1sqtzwujiq.s[63]++;
      this.selectedItem.RIGHT_STR__TABLE = {};
      var list = (cov_1sqtzwujiq.s[64]++, []);
      var data = (cov_1sqtzwujiq.s[65]++, this.selectedItem.RIGHT_STR.split(';'));
      cov_1sqtzwujiq.s[66]++;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _el2 = _step.value;

          var c = (cov_1sqtzwujiq.s[67]++, _el2.split(':'));
          cov_1sqtzwujiq.s[68]++;
          list[c[0]] = c[1];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      cov_1sqtzwujiq.s[69]++;
      for (var el in list) {
        cov_1sqtzwujiq.s[70]++;

        switch (eval(list[el])) {
          case 1:
            cov_1sqtzwujiq.b[14][0]++;
            cov_1sqtzwujiq.s[71]++;

            this.selectedItem.RIGHT_STR__TABLE[el] = [true, false, false];
            cov_1sqtzwujiq.s[72]++;
            break;
          case 2:
            cov_1sqtzwujiq.b[14][1]++;
            cov_1sqtzwujiq.s[73]++;

            this.selectedItem.RIGHT_STR__TABLE[el] = [true, true, false];
            cov_1sqtzwujiq.s[74]++;
            break;
          case 3:
            cov_1sqtzwujiq.b[14][2]++;
            cov_1sqtzwujiq.s[75]++;

            this.selectedItem.RIGHT_STR__TABLE[el] = [true, true, false];
            cov_1sqtzwujiq.s[76]++;
            break;
          case 4:
            cov_1sqtzwujiq.b[14][3]++;
            cov_1sqtzwujiq.s[77]++;

            this.selectedItem.RIGHT_STR__TABLE[el] = [true, false, true];
            cov_1sqtzwujiq.s[78]++;
            break;
          case 5:
            cov_1sqtzwujiq.b[14][4]++;
            cov_1sqtzwujiq.s[79]++;

            this.selectedItem.RIGHT_STR__TABLE[el] = [true, false, true];
            cov_1sqtzwujiq.s[80]++;
            break;
          case 6:
            cov_1sqtzwujiq.b[14][5]++;
            cov_1sqtzwujiq.s[81]++;

            this.selectedItem.RIGHT_STR__TABLE[el] = [true, true, true];
            cov_1sqtzwujiq.s[82]++;
            break;
          case 7:
            cov_1sqtzwujiq.b[14][6]++;
            cov_1sqtzwujiq.s[83]++;

            this.selectedItem.RIGHT_STR__TABLE[el] = [true, true, true];
            cov_1sqtzwujiq.s[84]++;
            break;
          default:
            cov_1sqtzwujiq.b[14][7]++;
            cov_1sqtzwujiq.s[85]++;

            this.selectedItem.RIGHT_STR__TABLE[el] = [false, false, false];
            cov_1sqtzwujiq.s[86]++;
            break;
        }
      }
      // parametrage des utilisateurs
      cov_1sqtzwujiq.s[87]++;
      this.selectedItem.USER_LIST__TABLE = {};
      cov_1sqtzwujiq.s[88]++;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.selectedItem.USER_LIST.split(';')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _el3 = _step2.value;
          cov_1sqtzwujiq.s[89]++;

          this.selectedItem.USER_LIST__TABLE[_el3] = true;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    cancel: function cancel() {
      cov_1sqtzwujiq.s[90]++;

      this.selectedItem = null;
    }
  };
  cov_1sqtzwujiq.s[91]++;
  $scope.privileges.getAllUser();
  cov_1sqtzwujiq.s[92]++;
  $scope.profils.getAll();
});